export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.amantioman.com",
    backendUrl: "http://localhost:3100",
    jsReportUrl: "http://localhost:5488",
    travelAgentBackendUrl: "http://localhost:3000",
    adminRepoLocation: "http://localhost:3000",
    bookingAppRepoLocation: "http://localhost:3001",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.amantioman.com";
    exportResult.backendUrl = "https://sg-api.amantioman.com/admin";
    exportResult.jsReportUrl = "https://sg-report.amantioman.com";
    exportResult.travelAgentBackendUrl = "https://sg-api.amantioman.com/business";
    exportResult.adminRepoLocation = "https://sg-admin.amantioman.com";
    exportResult.bookingAppRepoLocation = "https://sg-booking.amantioman.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.amantioman.com.my";
    exportResult.travelAgentBackendUrl = "https://business-api.travoxis.com";
    exportResult.adminRepoLocation = "https://admin.travoxis.com";
    exportResult.bookingAppRepoLocation = "https://booking.travoxis.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.amantioman.com";
    exportResult.backendUrl = "https://api.amantioman.com/admin";
    exportResult.jsReportUrl= "https://report.amantioman.com";
    exportResult.travelAgentBackendUrl =  "https://api.amantioman.com/business";
    exportResult.adminRepoLocation = "https://admin.amantioman.com";
    exportResult.bookingAppRepoLocation = "https://booking.amantioman.com";
  }
  return exportResult;
};
